import {FC} from 'react'
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'

const Error404: FC = () => {
  return (
    <div className='d-flex flex-column flex-root'>
      <div className='d-flex flex-column flex-center flex-column-fluid p-10'>
        {/* begin::Illustration */}
        <img
          src={toAbsoluteUrl('/media/brand/mascot-question.svg')}
          alt=''
          className='mw-100 mb-10 h-lg-300px'
        />
        {/* end::Illustration */}
        {/* begin::Message */}
        <h1 className='fw-bold mb-10' style={{color: '#572545'}}>
        Parece que no hay nada aquí
        </h1>
        {/* end::Message */}
        {/* begin::Link */}
        <Link to='/general' className='btn btn-primary'>
          Regresar al inicio
        </Link>
        {/* end::Link */}
      </div>
    </div>
  )
}

export {Error404}
